/* eslint-disable */
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { useCustomerStore } from '@/stores/customer';
import { useKycStore } from '@/stores/kyc';
import { openModal } from '@kolirt/vue-modal';
import { useBestlineVideoStore } from '@/stores/bestline_video';
import CasinoLimits from '@/components/modals/CasinoLimits.vue';

const sbSocketData = () => {
	if (!process.env.VUE_APP_PUSHER_KEY) {
		// cannot connect to pusher without key, so just return
		return;
	}
	
	const customerStore = useCustomerStore();

	window.Pusher = Pusher;

	window.Echo = new Echo({
		broadcaster: process.env.VUE_APP_PUSHER_BROADCASTER || 'pusher',
		key: process.env.VUE_APP_PUSHER_KEY,
		cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
		wsHost: process.env.VUE_APP_PUSHER_HOST || window.location.hostname,
		wsPort: process.env.VUE_APP_PUSHER_PORT,
		forceTLS: process.env.VUE_APP_PUSHER_FORCE_TLS === 'true',
		disableStats: true,
		authEndpoint: process.env.VUE_APP_API_URL + '/subscribe',
		auth: {
			headers: {
				Authorization: `Bearer ${customerStore.auth_token}`, // BIRA TOKEN
			}
		}
	});

	window.Echo.channel('messages')
		.listen('.sb', (event) => {
			console.log(event);
		})
		.listen('.video-streaming', (event) => {
			useBestlineVideoStore().setVideoEvents(event.message);
		});

	if (customerStore.isLoggedIn) {
		window.Echo.private(`messages.${customerStore.customer.id}`)
			.listen('.private_message', (event) => {
				console.log(event);
			})
			.listen('.update_balance', (event) => {
				customerStore.setCustomerBalance(event.message);
			})
			.listen('.casino_limit_notification', (event) => {
				openModal(CasinoLimits, { data: event.message }).catch(() => {});
			})
			.listen('.live_casino_limit_notification', (event) => {
				openModal(CasinoLimits, { data: event.message }).catch(() => {});
			})
			.listen('.kyc_completed', (event) => {
				useKycStore().receiveCompletionEvent(event.message);
			})
			// .listen('.referral_activity', (event) => {
			// 	console.log(event);
			// })
	}
};

export default sbSocketData;
